import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../App';

const ROLE_LABELS = {
  superadmin: { label: 'Süper Admin', color: '#7c3aed', bg: '#f3e8ff' },
  admin: { label: 'Merkez Sorumlusu', color: '#1d4ed8', bg: '#dbeafe' },
  viewer: { label: 'Kullanıcı', color: '#047857', bg: '#d1fae5' },
};

export default function Navbar() {
  const { user, profile } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    localStorage.clear();
    await supabase.auth.signOut();
    window.location.href = '/login';
  }

  if (!user) return null;

  const roleInfo = ROLE_LABELS[profile?.role] || ROLE_LABELS.viewer;

  return (
    <nav style={styles.nav}>
      <div style={styles.left}>
        <Link to="/" style={styles.brand}>
          🔬 Klinik Çalışma Takip Programı
          <span style={styles.brandSub}>Tüm çalışmaları görmek için tıklayın</span>
        </Link>
      </div>
      <div style={styles.right}>
        {(profile?.role === 'superadmin' || profile?.role === 'admin') && (
          <Link to="/admin" style={styles.link}>⚙️ Yönetim <span style={{ color: '#bfdbfe', fontSize: '0.8rem' }}>(Yeni Çalışma Ekle)</span></Link>
        )}
        <span style={styles.userInfo}>
          {profile?.full_name || profile?.email}
          <span style={{ ...styles.roleBadge, color: roleInfo.color, background: roleInfo.bg }}>
            {roleInfo.label}
          </span>
        </span>
        <button style={styles.logoutBtn} onClick={handleLogout}>Çıkış</button>
      </div>
    </nav>
  );
}

const styles = {
  nav: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 2rem', background: '#1e3a5f', color: 'white', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 2px 8px rgba(0,0,0,0.2)' },
  left: { display: 'flex', alignItems: 'center', gap: '1.5rem' },
  right: { display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' },
  brand: { color: 'white', textDecoration: 'none', fontWeight: 'bold', fontSize: '1.3rem', lineHeight: 1.3 },
  brandSub: { display: 'block', fontSize: '0.8rem', fontWeight: '400', color: '#93c5fd', marginTop: '0.2rem' },
  link: { color: '#93c5fd', textDecoration: 'none', fontSize: '1rem' },
  userInfo: { fontSize: '0.95rem', color: '#cbd5e1', display: 'flex', alignItems: 'center', gap: '0.5rem' },
  roleBadge: { padding: '0.2rem 0.7rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: '600' },
  logoutBtn: { background: 'transparent', border: '1px solid #475569', color: '#cbd5e1', padding: '0.5rem 1rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
};
